import { addActivities, displayActivitiesHeader } from '../functions.js';

jQuery(function($) {
    if ($('.archive-activiteit').length == 0) {
        return;
    }

    $.get("/wp-json/wemake/v1/get-token", function (response) {
        if (response.token) {
            fetchActivities(response.token);
        }
        else {
            console.log('no valid token');
        }
    });

    function fetchActivities(token){
        $.ajax({
            url: 'https://cockpit.qr-fit.nl/ext-website/v1/activities',
            method: "GET",
            headers: { "Authorization": "Bearer " + token },
            success : function(response) {
                displayActivitiesHeader(response);
                addActivities(response);
                console.log(response);
                $('.meer-activiteiten').on('click', displayMoreActivities);
            }
        });
    }
    
    
    

    function displayMoreActivities(){
        let page = $(this).data('page');
        $(this).remove();
        $(".activiteiten__results-wrap").addClass('loading');     
        $.get("/wp-json/wemake/v1/get-token", function (response) {
            if (response.token) {
                $.ajax({
                    url: 'https://cockpit.qr-fit.nl/ext-website/v1/activities?page=' + page,
                    method: "GET",
                    headers: { "Authorization": "Bearer " + response.token },
                    success: function (response) {
                        console.log(response);
                        addActivities(response);        
                        $('.meer-activiteiten').on('click', displayMoreActivities);
        
                    },
                    error: function (xhr) {
                        console.error("Failed to fetch activities: " + xhr.responseText);
                    }
                });
            }
            else{
                console.log('Error getting token');
            }
        });
    }
});



